import { DayOfWeek, IGeneralSettings } from 'shared/api/api';

export const validateGeneralSettings = (listSetting: IGeneralSettings) => {
	if (!listSetting.siteId) {
		return false;
	}
	return true;
};